// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChannelsPage/style.scss
// module id = 1119
// module chunks = 0